module.exports = __webpack_public_path__ + "img/image_3_4.aeb14236.jpg";